import { render, staticRenderFns } from "./TrafficFineUploadExcel.vue?vue&type=template&id=b461f8f4&"
import script from "./TrafficFineUploadExcel.vue?vue&type=script&lang=js&"
export * from "./TrafficFineUploadExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports